/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import MinimumDistanceSlider from '../slider/slider';
import './Filter.css';
import { AppContext } from '../../Context/app-state';
import FilterShape from '../filter-shape/filter-shape';
import FilterColor from '../filter-color/filter-color';
import FilterFavorite from '../filter-favorite/filter-favorite';
import FilterValue from '../filter-value/filter-value';
import SortsToys from '../sorting/sorting';
import { InitialFilters } from '../../Context/app-type';

const Filter = () => {
  const { filters, setFilters } = React.useContext(AppContext);

  const resetFilters = () => {
    setFilters(InitialFilters);
  };
  const resetLocal = () => {
    window.localStorage.clear();
    alert('Local Storage очищен! Пожалуйста, обновите страницу');
  };

  return (
    <div className="App-filters">
      <div className="App-filters__filter">
        <div className="filter-title">Фильтры по значению</div>
        <FilterShape />
        <FilterColor />
        <FilterValue />
        <div className="filter-favorite">
          Только любимые:
          <FilterFavorite />
        </div>
      </div>
      <div className="App-filters__range">
        <div className="range-title">Фильтры по диапазону</div>
        <MinimumDistanceSlider />
      </div>
      <div className="App-filters__sort">
        <div className="sort-title">Сортировка</div>
        <SortsToys />
        <button className="sort-reset" type="button" onClick={resetFilters}>
          Сброс фильтров
        </button>
        <button className="sort-reset" type="button" onClick={resetLocal}>
          Сброс LocalStorage
        </button>
      </div>
    </div>
  );
};

export default Filter;
